import { t } from "@lingui/core/macro";
import { type PrimitiveAtom, useAtom } from "jotai";
import { Temporal } from "temporal-polyfill";

import { Icon } from "_/components/icon";

import { type PrintViewControls } from "_/state/viewer";

import { formatHourMinuteDuration } from "_/utils/datetime";

import * as S from "./styled";

const DATA_REFRESH_DELAY_LIMIT = Temporal.Duration.from({ seconds: 60 });

export const StaleDataAlert = ({
  controlsAtom,
}: {
  controlsAtom: PrimitiveAtom<PrintViewControls>;
}) => {
  const [{ staleData, hideStaleDataAlert }, setControls] =
    useAtom(controlsAtom);
  if (!staleData || hideStaleDataAlert) {
    return null;
  }

  const { dataUpdatedAt, statusTimestamp, onRefresh } = staleData;
  const availableDuration = Temporal.Instant.fromEpochMilliseconds(
    dataUpdatedAt
  ).until(Temporal.Instant.from(statusTimestamp));

  if (
    Temporal.Duration.compare(availableDuration, DATA_REFRESH_DELAY_LIMIT) <= 0
  ) {
    return null;
  }

  const timeRange = formatHourMinuteDuration(availableDuration);

  return (
    <S.Alert kind="info">
      <S.Content>
        <span>{t`components.controls.analyze.more-data-available ${timeRange}`}</span>
        <S.Actions>
          <S.RefreshButton
            title={t`components.controls.analyze.refresh-print-data`}
            variant="text"
            size="large"
            iconOnly
            onClick={onRefresh}
          >
            <Icon variant="Refresh" />
          </S.RefreshButton>
          <S.CloseButton
            title={t`common.close`}
            variant="text"
            kind="secondary"
            iconOnly
            onClick={() =>
              setControls((controls) => ({
                ...controls,
                hideStaleDataAlert: true,
              }))
            }
          >
            <Icon variant="Close" />
          </S.CloseButton>
        </S.Actions>
      </S.Content>
    </S.Alert>
  );
};
